import { defineStore } from "pinia";
import { ref, watch } from "vue";

const STORAGE_KEY = "rih_notification_sound_enabled";

// Единый AudioContext: создаётся лениво и переиспользуется. Браузеры держат
// контекст в состоянии "suspended" (звук молчит), пока пользователь не
// взаимодействовал со страницей — поэтому разблокируем его на первом жесте.
let audioContext = null;

const getAudioContext = () => {
    if (!audioContext) {
        const AudioContextClass =
            window.AudioContext || window.webkitAudioContext;

        if (!AudioContextClass) return null;

        audioContext = new AudioContextClass();
    }

    return audioContext;
};

const unlockAudioContext = () => {
    const context = getAudioContext();

    if (context && context.state === "suspended") {
        context.resume();
    }
};

// Разблокировка по первому жесту пользователя (click/keydown). После этого
// realtime-уведомления из сокета смогут проигрывать сигнал без запрета браузера.
if (typeof window !== "undefined") {
    const onFirstGesture = () => {
        unlockAudioContext();
        window.removeEventListener("pointerdown", onFirstGesture);
        window.removeEventListener("keydown", onFirstGesture);
    };

    window.addEventListener("pointerdown", onFirstGesture);
    window.addEventListener("keydown", onFirstGesture);
}

export const useNotificationSoundStore = defineStore(
    "NotificationSoundStore",
    () => {
        const enabled = ref(localStorage.getItem(STORAGE_KEY) !== "false");

        watch(enabled, (value) => {
            localStorage.setItem(STORAGE_KEY, value ? "true" : "false");
        });

        const play = () => {
            if (!enabled.value) return;

            try {
                const context = getAudioContext();

                if (!context) return;

                if (context.state === "suspended") {
                    context.resume();
                }

                const now = context.currentTime;

                [
                    [880, 0],
                    [1175, 0.12],
                ].forEach(([frequency, offset]) => {
                    const oscillator = context.createOscillator();
                    const gain = context.createGain();

                    oscillator.type = "sine";
                    oscillator.frequency.setValueAtTime(
                        frequency,
                        now + offset
                    );
                    oscillator.connect(gain);
                    gain.connect(context.destination);

                    gain.gain.setValueAtTime(0, now + offset);
                    gain.gain.linearRampToValueAtTime(
                        0.35,
                        now + offset + 0.02
                    );
                    gain.gain.exponentialRampToValueAtTime(
                        0.0001,
                        now + offset + 0.3
                    );

                    oscillator.start(now + offset);
                    oscillator.stop(now + offset + 0.3);
                });
            } catch (e) {
                console.warn("Failed to play notification sound:", e);
            }
        };

        return { enabled, play };
    }
);
